const wrappedContracts: Record<number, string> = {
  4337: '0xD51BFa777609213A653a2CD067c9A0132a2D316A', // beam
  13337: '0xF65B6f9c94187276C7d91F4F74134751d248bFeA', // beam testnet
  13371: '0x3A0C2Ba54D6CBd3121F01b96dFd20e99D1696C9D', // immutable zkEvm
  13473: '0x1CcCa691501174B4A623CeDA58cC8f1a76dc3439', // immutable zkEvm testnet
  531050104: '0x9B7EA63EF5062661570afe548e3AD691D5652527', // sophon testnet
};

export default wrappedContracts;
